import Sidebar from "../sidebar/Sidebar";
import Footer from "../components/Footer";
import kellieMainImg from "../images/me/kellie-main.JPEG";

const About = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Sidebar page={"About"} />
      <div className="flex-1 px-4 py-4 lg:px-8 lg:py-6 bg-lightBg text-lightText dark:bg-darkBg dark:text-darkText">
          <h1 className="text-2xl xl:text-3xl font-bold mb-4 text-lightText dark:text-darkText">
            About Me
          </h1>

          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Biography
            </h2>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              Hello! My name is Kellie, or sometimes known as ‘kelliepanda’ on
              the Internet. I am always looking to harness my engineering and
              technological skills to serve others in medical and healthcare
              settings. I'm a 3rd-year PhD student at SUTD, exploring the
              intersection of Human-AI Interaction and sensitive care contexts.
              My research focuses on leveraging AI to support sensitive care
              contexts such as mental health and advance care planning, aiming
              to enhance user experiences with empathetic and supportive
              human-AI interactions. A side interest of mine is in the area of
              neurodiversity, and how technology and neurodiversity can
              intersect to create more inclusive and supportive environments.
              See my{" "}
              <a href="/home#research-agenda" className="text-green dark:text-green-dark underline underline-offset-2">
                Research
              </a>{" "}
              section for more details!
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              I completed my undergraduate studies at SUTD, where I graduated
              with a Bachelor of Engineering (Computer Science and Design). I
              have been actively involved in student life and campus activities
              during my time at SUTD. I have held multiple leadership positions
              in student clubs and societies, and have been actively involved in
              community service and volunteer work. These include the
              Vice-President (Operations) of SUTD’s Student Government and
              Student Association Council, President of the Rotaract Club of
              SUTD, Community Cluster Representative in the Student Association
              Council, Secretary of the House Guardians, and more. I also worked
              on several research projects during my undergraduate studies,
              where I gained experience in conducting research and writing
              research papers.
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              Seeing my peers struggle with their mental health has made me
              realise that much more can be done for the youths of tomorrow.
              Outside of school, I am also involved in the local mental health
              scene, such as by being an avid advocate on my Instagram page (
              <a
                href="https://instagram.com/kelliepandasg"
                target="_blank"
                and
                rel="noopener noreferrer"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                @kelliepandasg
              </a>
              ), a Community Peer Supporter under Youth Corps Singapore's{" "}
              <a
                href="https://linktr.ee/projectreground"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                Project Re:ground
              </a>
              , a Youth Fellow under{" "}
              <a
                href="https://mindline.sg"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                mindline.sg
              </a>
              , working at a local mental health startup (
              <a
                className="text-green dark:text-green-dark underline underline-offset-2"
                href="https://kurakura.io/"
                target="_blank"
                and
                rel="noopener noreferrer"
              >
                Kura Kura
              </a>
              ), and through various other projects (see the{" "}
              <a
                className="text-green dark:text-green-dark underline underline-offset-2"
                href="/mental-health"
                target="_blank"
                and
                rel="noopener noreferrer"
              >
                Mental Health Work
              </a>{" "}
              page for more information).
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              Having been involved on the ground in my local community since
              young, I am passionate about making a difference to society. I’ve
              initiated and led community service projects in my various
              educational institutions, and embarked on a social leadership trip
              to Taiwan.
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              In addition, I have a deep passion for learning about global
              cultures and fostering cross-cultural understanding. Over the past
              five years alone, I have embarked on several global exposures to
              broaden my horizons. I have actively sought opportunities to
              explore both Western countries and Eastern countries. By immersing
              myself in diverse cultural environments, I have gained valuable
              insights into the similarities and differences between these
              regions and my home country, further shaping my global perspective
              and ability to connect with individuals from various backgrounds.
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              My goal is to combine my technical skills with my passion for
              social impact to create technology that makes a positive
              difference in people’s lives.
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              I also go by “Kellie Yu Hui Sim” or “Kellie Sim”. My Chinese name
              is “沈于惠”.
            </p>
          </section>

          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Photo
            </h2>
            <div className="mt-4 max-w-md overflow-hidden rounded-lg">
              <img
                src={kellieMainImg}
                alt="Kellie Yu Hui Sim"
                className="w-full rounded-lg object-cover object-top"
              />
            </div>
          </section>
          {/* <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Skills & Expertise
            </h2>
            <ul className="mt-4 list-disc space-y-1 pl-4 text-sm leading-relaxed text-gray-700 dark:text-gray-300">
              <li>
                Technical: Breadboard Fabrication and Testing, Microcontroller
                Programming and Interfacing
              </li>
              <li>
                Programming: Python, HTML, Arduino, JavaScript, CSS, C, C#, C++,
                Java, React, React Native, MATLAB
              </li>
              <li>Languages: English, Chinese, Korean</li>
              <li>Business: China Readiness, Social Innovation</li>
              <li>Design: Design Innovation, Canva, Figma</li>
            </ul>
          </section> */}
          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Personal Interests
            </h2>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              Outside of my academic pursuits, I enjoy(ed) ice-skating and
              inline skating. I'm also trying to get back into reading (about
              brains! I am fascinated by how our brains can learn more about
              other brains and how brains can come up with ideas or concepts
              about actions taken by other brains...etc.).
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              I enjoy listening to music (especially K-pop). My all-time
              favourites include: BIGBANG (OT4), 2NE1, HIGHLIGHT/BEAST, iKON
              (OT7), Monsta X (OT7), BLACKPINK (it was so hard to choose!!!).
            </p>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              I also love going to concerts and music festivals! There's a high
              chance I'll be found at a concert or a music festival if there's
              one happening. During my exchange programmes to the United States
              and South Korea, I attended several concerts and music festivals,
              such as KCON LA and iKON's concert in Seoul, among many others. I
              also flew back to Singapore to attend BLACKPINK's concert during
              my exchange in South Korea. Other concerts I have attended
              include: G-Dragon, 2NE1, iKON, B.I, Monsta X, I.M, BLACKPINK,
              TWICE, SEVENTEEN, ITZY, (G)I-DLE, IVE, INFINITE, Apink, HIGHLIGHT,
              WINNER, DAY6, AKMU, 2NE1, Lee Youngji, Dean, Tabber, Melanie
              Martinez, Big Time Rush, Mayday (with Stefanie Sun as a special
              guest). Festivals such as KCON LA 2023, Seoul Festa 2023,
              Hiphopplaya Festival 2023, and Daegu Hip-hop Festival 2023 were
              also memorable experiences since I got to see so many artists just
              through one event! Excitingly, I also got to hear PSY, H1-KEY, Jo
              Yuri, and Mirani live during KAIST's Spring Festival 2023. I made
              a (partially-updated) Notion page to keep track of the concerts I
              have attended, which you can find{" "}
              <a
                href="https://kellief0rnia.notion.site/concerts-attended-15e67098a1a2809392a5d8b8466c2371?pvs=74"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                here
              </a>
              .
            </p>
          </section>
          <section>
            <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
              Contact Information
            </h2>
            <p className="text-sm leading-relaxed text-gray-700 dark:text-gray-300 mt-4">
              Feel free to reach out to me via email at{" "}
              <a
                href="mailto:kelliesyhh@gmail.com"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                kelliesyhh@gmail.com
              </a>{" "}
              or connect with me on{" "}
              <a
                href="https://www.linkedin.com/in/kelliesim"
                className="text-green dark:text-green-dark underline underline-offset-2"
              >
                LinkedIn
              </a>
              .
            </p>
          </section>

          {/* <section>
      <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
        Awards
      </h2>
      {awards.map((item, index) => (
        <Award
          key={index}
          organisation={item.organisation}
          award={item.award}
          duration={item.duration}
          jobscope={item.jobscope}
        />
      ))}
    </section>

    <section>
      <h2 className="text-xl xl:text-2xl font-semibold text-lightText dark:text-darkText mb-1.5 mt-8">
        Certifications
      </h2>
      <ol className="list-decimal break-normal">
        {certifications.map((item, index) => (
          <li key={index} className="mb-4">
            <p className="text-xl font-medium mt-2">{item.title}</p>
            <div className="flex items-center mb-1">
              <p className="text-base lg:text-md flex-1">
                {item.organisation}
              </p>
              <p className="text-sm">{item.year}</p>
            </div>
            <a
              href={item.credential}
              target="_blank"
              className="underline underline-offset-2 hover:font-semibold text-green dark:text-green-dark text-sm mt-2"
            >
              View Credential
            </a>
          </li>
        ))}
      </ol>
    </section> */}
      </div>
      <Footer />
    </div>
  );
};

export default About;
